export default __webpack_public_path__ + "static/media/companiesBg.c8ebfdda.svg";